<template>
  <div style="width: 100%">
    <div>
      <el-input v-model="query.account_id" style="width:250px;margin-right: 10px" placeholder="请输入账号id" />
      <el-button type="primary" @click="search">搜索</el-button>
      <el-button type="info" @click="reset">重置</el-button>
    </div>
    <el-table
      style="margin-top: 10px;"
      :data="account_list"
      border
    >
      <el-table-column
        fixed
        label="子账号id"
        width="120px"
      >
        <template slot-scope="scope">
          <el-checkbox
            v-model="selectedRows"
            :label="scope.row.account_id"
          />
        </template>
      </el-table-column>
      <el-table-column label="子账号名称" prop="account_name" />
      <el-table-column label="子账户状态" prop="account_status_text" />
    </el-table>
    <pagination-right
      :current-page="query.page"
      :total="total"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />
    <div>
      <el-button type="info" @click="$emit('close')">取消</el-button>
      <el-button type="success" @click="commit">提交</el-button>
    </div>
  </div>
</template>
<script>

import PaginationRight from '@/components/PaginationRight/index.vue'
import { advertiserList } from '@/api/customer'

export default {
  components: { PaginationRight },
  data() {
    return {
      query: {
        page: 1,
        pageSize: 10,
        account_id: null
      },
      account_list: [],
      total: 0,
      selectedRows: []
    }
  },
  created() {
    this.list()
  },
  methods: {
    list() {
      advertiserList(this.query).then(res => {
        this.total = res.data.total
        this.account_list = res.data.list
      })
    },
    fetchPageSize(e) {
      this.query.pageSize = e
      this.list()
    },
    fetchCurrentPage(e) {
      this.query.page = e
      this.list()
    },
    search() {
      this.query.page = 1
      this.query.pageSize = 10
      this.list()
    },
    reset() {
      this.query.page = 1
      this.query.pageSize = 10
      this.query.account_id = null
      this.list()
    },
    commit() {
      this.$emit('bind', this.selectedRows)
    }
  }
}
</script>

<style lang="less" scoped>
</style>
